import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <BrowserRouter>
    <Routes>
      <Route path="/ResetPassword" element={<ResetPassword />} />      
    </Routes>
    </BrowserRouter>
  );
}

export default App;
